<script>
import {SysExCommand} from "@/assets/js/SysExCommand";
import HintComponent from "@/components/HintComponent.vue";

export default {
  components: {HintComponent},
  emits: ['InputChanged'],
  props: {
    commandLabel: {
      default: "",
      type: String
    },
    listOfVariants: {
      default: {},
    },
    commandObject: {
      required: true,
      type: SysExCommand
    },
    description: {
      type: String,
      required: false,
    },
    showDescription: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      Value: 0
    }
  },
  computed: {
    fieldId() {
      return `setting-${this.commandObject.name.replace(/[^a-z0-9_-]/gi, "-")}`
    }
  },
  methods: {
    changed() {
      this.$emit('InputChanged', this.commandObject)
    }
  },
  watch: {
    Value() {
      this.commandObject.set_value(this.Value)
    }
  },
  mounted() {
    this.Value = this.commandObject.value;
  }
}
</script>

<template>
  <div class="row">
    <label :for="fieldId" class="fw-semibold">
      {{ this.commandLabel }}
      <HintComponent v-if="this.description && !showDescription" :text="this.description" />
    </label>
    <p v-if="this.description && showDescription" class="setting-help text-muted mb-2">{{ this.description }}</p>

    <select v-model="this.Value" :id="fieldId" class="form-control" @change="changed">
      <option v-for="(item, index) in this.listOfVariants" v-bind:key="index" :value="index">
        {{item}}
      </option>
    </select>
  </div>
</template>

<style scoped>
.setting-help { line-height: 1.45; }
</style>
